import { render, staticRenderFns } from "./ReferrerCategoryTag.vue?vue&type=template&id=130450c4&scoped=true&"
import script from "./ReferrerCategoryTag.vue?vue&type=script&lang=ts&"
export * from "./ReferrerCategoryTag.vue?vue&type=script&lang=ts&"
import style0 from "./ReferrerCategoryTag.vue?vue&type=style&index=0&id=130450c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130450c4",
  null
  
)

export default component.exports